import React, { useState } from "react";
import { useSelector } from "react-redux";
import  {MenuContainer}  from "../../component/MenuContainer";
import "primeicons/primeicons.css";
import SearchContainer from "component/HomeSlider/SearchContainer/SearchContainer";
import NewMenuContainer from "component/HomeSlider/NewMenuContainer/newMenuContainer";
import { useNavigate } from "react-router-dom";
import { FaChevronRight,FaChevronDown } from "react-icons/fa6";
import icon4 from '../../assets/images/Asset4.png'
import icon5 from '../../assets/images/Asset5.png'
import quantamCross from '../../assets/images/quantamCross.jpeg'
// import icon4 from '../../assets/images'

import logo from "../../assets/red_logo.png";

export const Header = () => {
  const { data: dashboardData } = useSelector((state) => state.dashboard);
  const [isMenu, setIsMenu] = useState(false);
  const [isSearch, setIsSearch] = useState(false);
  const [openSubmenu, setOpenSubmenu] = useState(null);
  // const [activeDiv, setActiveDiv] = useState('aboutQuantum');

  const toggleSubmenu = (index) => {
    setOpenSubmenu(openSubmenu === index ? null : index); 
  };

  const handleItemClick = (item, route) => {
    setActiveDiv(item);
    if (route) {
      navigation(route);
      setIsMenu(false);
    }
  };

  const navigation = useNavigate()

  const handleNavigation = (path) => () => {
    navigation(path);
    setIsMenu(!isMenu)
  };

  const [activeDiv, setActiveDiv] = useState('aboutQuantum'); // Default to 'aboutQuantum' only at the start

  const renderDivContent = () => {
    switch (activeDiv) {
      case 'aboutQuantum':
        return (
          <ul style={{paddingLeft:'0px'}} className="AboutQuantumDiv midNavDiv">
            <li className="list-style" onClick={handleNavigation('/about-us')}>Overview</li>
          <li className="list-style" onClick={handleNavigation('/history')}>Our History</li>
          <li className="list-style" onClick={handleNavigation('/our-people')}>Our People</li>
          <li className="list-style" onClick={handleNavigation('/contact-us')}>Contact Us</li>
          </ul>
        );
      case 'services':
        return (
          <ul style={{paddingLeft:'0px'}} className="ServicesDiv midNavDiv">
            <li className="list-style" onClick={handleNavigation('/our-services')}>Overview</li>
            <li className="list-style" onClick={handleNavigation('/investor-services')}>For Investor</li>
            <li className="list-style" onClick={handleNavigation('/developer-services')}>For Developers</li>
            <li className="list-style" onClick={handleNavigation('/other-services')}>For Others</li>
            
          </ul>
        );
      case 'impact':
        return (
          <ul style={{paddingLeft:'0px'}} className="impactDiv midNavDiv">
            {/* <li className="list-style" onClick={handleNavigation('/community_impect')}>Community Impact</li> */}
            <li className="list-style" onClick={handleNavigation('/social_responsibility')}>Social Responsibility</li>
          </ul>
        );
      case 'insight':
        return (
          <ul style={{paddingLeft:'0px'}} className="InsightsDiv midNavDiv">
            {/* <li className="list-style">6</li>
            <li className="list-style">7</li> */}
          </ul>
        );
      case 'clients':
        return (
          <ul style={{paddingLeft:'0px'}} className="ClientsDiv midNavDiv">
            {/* <li className="list-style">8</li>
            <li className="list-style">9</li>
            <li className="list-style">10</li> */}
          </ul>
        );
      case 'job':
        return (
          <ul style={{paddingLeft:'0px'}} className="JobPostingsDiv midNavDiv">
            {/* <li className="list-style">11</li>
            <li className="list-style">12</li>
            <li className="list-style">13</li> */}
          </ul>
        );
      default:
        return null;
    }
  };

  return (
    <header className={`py-0 bg-gray header  border-black-700 ${isMenu ? "border-bottom-0" : 'border-bottom-1'}  navHeader`} style={{backgroundColor:'#F5F4F1'}}>
      <div className=" container1 p-0" >
      <div  
        className="grid align-items-center "
        // style={{backgroundColor:'red',zIndex:99999000}}
        // style={{ backgroundColor: "white" }}
      >
        <div className="col-4 md:col-4 sm:col-4 pb-0 " >
          <button
            className="btn bg- border-none shadow-none p-0 lg:ml-6 cursor-pointer  marginLeftFive  text-center menuCLoseIconContainer"
            onClick={() => setIsMenu(!isMenu)}
          >
            {/* <i className={`pi ${isMenu ? "pi-times" : "pi-bars"} thm-red fs-2 menuCLoseIcon `}  /> */}
            {isMenu ?
            <img className="ml-3 class24 " src={ quantamCross }/> :
            <img className="ml-3 " src={ icon5 }/>}

          </button>
        </div>
        <div className="col-4 md:col-4 sm:col-4 my-2 ">
          <a href="/" className="logo-box flex justify-content-center m-auto">
            <img src={logo} alt="logo" className="img-fluid" />
          </a>
        </div>
        <div className="col-4 md:col-4 sm:col-4 text-right">
          <button type="button" className="bg-transparent lg:mr-6 md:mr-6 border-none shadow-none marginRightFive"
           onClick={() => setIsSearch(!isSearch)} >
            {/* <i className="pi pi-search text-2xl text-red-700 bg-transparent fs-0"></i> */}
            {/* <i className={`pi ${isSearch ? "pi-times" : "pi-search"} thm-red fs-2 menuCLoseIcon `}  /> */}
            {isSearch ?
            <img className="ml-3 class24 " src={ quantamCross }/> :
            <img className="ml-3 " src={ icon4 }/>}
         
          </button>
        </div>
      </div>
      </div>

      {/* comment this section  */}
      {/* /////////////////// */}

      {/* <div className="container1" style={{}}>
      {isMenu && <MenuContainer isMenuSelected={() => {setIsMenu(false)} }/>}
        
      </div> */}

      {/* /////////////////// */}



      {/* uncomment the following section for custom component of navbar
      ///////////////////////////////// */}


      <div className={`container1 navbarforDesktop  ${isMenu? 'border-top-1':'border-top-0'}`}  style={{borderColor:'grey'}}>
     
      {isMenu && 
       <div className=" navMaxWidth pl-0   d-flex" style={{ width: '98.5%' }}>
       <div style={{ width: '40%', height: '100%', backgroundColor: 'transparent' }}>
         <ul style={{paddingLeft:'0%'}}>
           <li
             className={`list-style ${activeDiv === 'aboutQuantum' ? 'active' : ''}`}
             onClick={() => setActiveDiv('aboutQuantum')}
           >
             About Quantum

             <FaChevronRight/>
           </li>
           <li
             className={`list-style ${activeDiv === 'services' ? 'active' : ''}`}
             onClick={() => setActiveDiv('services')}
           >
             Services
             <FaChevronRight/>
           </li>
           <li
             className={`list-style ${activeDiv === 'impact' ? 'active' : ''}`}
             onClick={() => setActiveDiv('impact')}
           >
             Impact
             <FaChevronRight/>
           </li>
           {/* <li
             className={`list-style ${activeDiv === 'insights' ? 'active' : ''}`}
             onClick={() => {setActiveDiv('insights');navigation('/insights');setIsMenu(!isMenu) }}
           >
             Insights & Updates
           </li> */}
           <li
             className={`list-style ${activeDiv === 'Projects' ? 'active' : ''}`}
             onClick={() =>{ setActiveDiv('Projects');navigation('/project-listing');setIsMenu(!isMenu)}}
           >
             Projects
           </li>
           <li
             className={`list-style ${activeDiv === 'clients' ? 'active' : ''}`}
             onClick={() =>{ setActiveDiv('clients');navigation('/clients');setIsMenu(!isMenu)}}
           >
             Clients
           </li>
           <li
             className={`list-style ${activeDiv === 'job' ? 'active' : ''}`}
             onClick={() =>{ setActiveDiv('job');navigation('/careers');setIsMenu(!isMenu)}}
           >
             Job Postings
           </li>
         </ul>
       </div>
 
       <div style={{ width: '30%', backgroundColor: '#d1d2d4' }}>
         {renderDivContent()}
       </div>
 
       <div style={{ width: '30%', backgroundColor: 'transparent' }}>
        
         <div
                    className="lg:col-12 md:col-12 sm:col-12 text-left p-0"
                    style={{
                      // backgroundColor:'red',
                      //  backgroundColor:'#F5F4F1',
                      display: "flex",
                      justifySelf: 'center',
                      // flexDirection: "column",
                      gap: "5px",
                      marginTop: '18px',
                      // marginLeft: '58px'
                      // alignItems: 'center',
                      // justifyContent: "flex-start"
                      // marginLeft:'50px'
                    }}
                  >
                    <div style={{ width: '100%', height: '100%', display: "flex", alignItems: 'center', justifyContent: 'flex-start', flexDirection: 'column', gap: '5px' }}>
                      <div className="" style={{ width: '80%' }}>
                        <span
                          style={{
                            fontSize: "18px",
                            color: "#444",
                            fontWeight: "550",
                            letterSpacing: "2px",
                            lineHeight: "20px",
                            textTransform: "uppercase",
                          }}
                        >
                          {dashboardData?.featured_title || "Featured content"}
                        </span>
                      </div>

                      <div className="" style={{ width: "80%", height: '70%', }}>
                        <img
                          src={
                            dashboardData?.featured_img ||
                            "media/home_banners.png"
                          }
                          alt={dashboardData?.featured_title || "Featured"}
                          className=""
                          style={{ width: '100%', height: '100%' }}
                        />
                      </div>

                      <div className="" style={{ width: '80%' }}>
                        <span
                          style={{
                            fontSize: "16px",
                            color: "#444",
                            fontWeight: "500",
                            // letterSpacing: "1.5px",
                            // lineHeight: "20px",
                            textAlign: 'left',
                            textJustify: 'none'

                          }}
                          className="fontAvo"
                        >
                          {dashboardData?.featured_description ||
                            "Hertz: Quantum’s Flexible Capital at Work"}
                        </span>
                      </div>
                    </div>
                  </div>
       </div>
     </div>
      }
        
      </div>




        {/* ////////////////////////////// */}


        <div className={`container1 bg-0 navbarforDesktop navbarForMobile ${isMenu ? 'border-top-1' : 'border-top-0'}`} style={{ borderColor: 'grey' }}>
      {isMenu && (
        <div className="w-full " style={{ height: 'fit-content' }}>
          <div className="w-full">
            <ul className="p-0">
              <li
                className={`list-style pl-4 ${activeDiv === 'aboutQuantum' ? 'active' : ''}`}
                onClick={() => {
                  toggleSubmenu(1);
                  handleItemClick('aboutQuantum');
                }}
              >
                About Quantum
                <FaChevronRight />
              </li>
              {openSubmenu === 1 && (
                <ul className="w-full pl-0" style={{backgroundColor: '#d1d2d4'}}>
                  <li className="list-style"  onClick={() =>{ navigation('/about-us'); setIsMenu(!isMenu)}}>Overview</li>
                  <li className="list-style" onClick={() =>{ navigation('/history'); setIsMenu(!isMenu)}}>Our History</li>
                  <li className="list-style" onClick={() =>{ navigation('/our-people'); setIsMenu(!isMenu)}}>Our People</li>
                  <li className="list-style" onClick={() =>{ navigation('/contact-us'); setIsMenu(!isMenu)}}>Contact Us</li>
                </ul>
              )} 

              <li
                className={`list-style pl-4 ${activeDiv === 'services' ? 'active' : ''}`}
                onClick={() => {
                  toggleSubmenu(2);
                  handleItemClick('services');
                }}
              >
                Services
                <FaChevronRight />
              </li>
              {openSubmenu === 2 && (
                <ul className="w-full pl-0" style={{backgroundColor: '#d1d2d4'}}>
                  <li className="list-style" onClick={() =>{ navigation('/our-services'); setIsMenu(!isMenu)}}>Overview</li>
                  <li className="list-style" onClick={() =>{ navigation('/investor-services'); setIsMenu(!isMenu)}}>For Investor</li>
                  <li className="list-style" onClick={() =>{ navigation('/developer-services'); setIsMenu(!isMenu)}}>For Developers</li>
                  <li className="list-style" onClick={() =>{ navigation('/other-services'); setIsMenu(!isMenu)}}>For Others</li>
                  
                </ul>
              )}

              <li
                className={`list-style pl-4 ${activeDiv === 'impact' ? 'active' : ''}`}
                onClick={() => {
                  toggleSubmenu(3);
                  handleItemClick('impact');
                }}
              >
                Impact
                <FaChevronRight />
              </li>
              {openSubmenu === 3 && (
                <ul className="w-full pl-0" style={{backgroundColor: '#d1d2d4'}}>
                  {/* <li className="list-style" onClick={() =>{ navigation('/community_impect'); setIsMenu(!isMenu)}}>Community Impact</li> */}
                  <li className="list-style" onClick={() =>{ navigation('/social_responsibility'); setIsMenu(!isMenu)}}>Social Responsibility</li>
                
                </ul>
              )}

              {/* <li
                className={`list-style pl-4 ${activeDiv === 'insights' ? 'active' : ''}`}
                onClick={() => handleItemClick('insights', '/insights')}
              >
                Insights & Updates
              </li> */}
              <li
                className={`list-style pl-4 ${activeDiv === 'projects' ? 'active' : ''}`}
                onClick={() => handleItemClick('projects', '/project-listing')}
              >
                Projects
              </li>
              <li
                className={`list-style pl-4 ${activeDiv === 'clients' ? 'active' : ''}`}
                onClick={() => handleItemClick('clients', '/clients')}
              >
                Clients
              </li>
              <li
                className={`list-style pl-4 ${activeDiv === 'job' ? 'active' : ''}`}
                onClick={() => handleItemClick('job', '/careers')}
              >
                Job Postings
              </li>
            </ul>
          </div>
        </div>
      )}
    </div>



      <div className="container1" style={{}}>
      {isSearch &&  <SearchContainer isMenuSelected={() => setIsSearch(false)}/>}
      
       
      </div>
    </header>
  );
};
